window.functions = window.functions || {};
window.functions.imageZoom = function() {
  const productImagesWrapper = document.querySelectorAll(".main-product .splide__list .product-media-object");

  productImagesWrapper.forEach(wrapper => {
    wrapper.addEventListener("mousemove", event => {
      if (window.innerWidth >= 1008) {
        zoomImageFunctionality(event);
      }
    });

    wrapper.addEventListener("mouseleave", event => {
      if (window.innerWidth >= 1008) {
        zoomOutFunctionality(event);
      }
    });
  });

  function zoomImageFunctionality(e) {
    let zoomer = e.currentTarget,
        imgElement = e.currentTarget.querySelector("img");

    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
    x = offsetX/zoomer.offsetWidth * 100 - 50;
    y = offsetY/zoomer.offsetHeight * 100 - 50;

    imgElement.style.transform = `scale(1.5) translate(${-x / 1.5}%, ${-y / 1.5}%)`;
  }

  function zoomOutFunctionality(e) {
    let imgElement = e.currentTarget.querySelector("img");

    imgElement.style.transform = `none`;
  }
};
